// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// ResendConfirmEmailHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';

interface Request {
    email: string | null;
    userId: string | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            email: "",
            userId: '00000000-0000-0000-0000-000000000000',
        },
        initValues);
    },
    email: 'email',
    userId: 'userId',
}

interface Result {
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(
        {
        },
        initValues);
    },
}

export { Request, Result };